import type { AxiosResponse } from 'axios';

import { apiSso } from '~/configs/api/apiConfig';
import type { IUserSession } from '~/types/api/Sessions';

export async function fetchDeviceSessions(
  deviceId: number,
): Promise<AxiosResponse<IUserSession[]>> {
  return apiSso.get(`/api/devices/${deviceId}/sessions`);
}

export async function revokeDeviceSession(
  deviceId: number,
  sessionId: number,
): Promise<AxiosResponse<void>> {
  return apiSso.post(`/api/devices/${deviceId}/sessions/${sessionId}/revoke`);
}

export async function logoutSession(refreshToken: string): Promise<AxiosResponse<void>> {
  return apiSso.post('/api/sessions/logout', { refreshToken });
}
